"use client";

import { c as _c } from "react/compiler-runtime";
import { motion, AnimatePresence } from "framer-motion";
import { commonImageVariants, commonTextVariants, useAutoSlider } from "@/hooks/animations/useAutoSlider";
import { Testimonial } from "@/lib/types";
import { Play } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
interface TestimonialCardProps {
  data: Testimonial[];
}
const TestimonialCard = t0 => {
  const $ = _c(64);
  const {
    data
  } = t0;
  let t1;
  if ($[0] !== data.length) {
    t1 = {
      totalItems: data.length
    };
    $[0] = data.length;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    activeIndex
  } = useAutoSlider(t1);
  const activeData = data[activeIndex];
  const totalLength = data.length;
  const currentProgressPercent = `${(activeIndex + 1) / totalLength * 100}%`;
  const t2 = String(totalLength);
  let t3;
  if ($[2] !== t2) {
    t3 = t2.padStart(2, "0");
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <span className="text-sm lg:text-xl font-bold text-white order-3 lg:order-1">{t3}</span>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      height: "0%"
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== currentProgressPercent) {
    t6 = {
      height: currentProgressPercent
    };
    $[7] = currentProgressPercent;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      duration: 0.8,
      ease: "anticipate"
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6) {
    t8 = <motion.div className="absolute bottom-0 left-0 w-full bg-white hidden lg:block" initial={t5} animate={t6} transition={t7} />;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      width: "0%"
    };
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== currentProgressPercent) {
    t10 = {
      width: currentProgressPercent
    };
    $[13] = currentProgressPercent;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      duration: 0.8,
      ease: "anticipate"
    };
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t10) {
    t12 = <motion.div className="absolute top-0 left-0 h-full bg-white lg:hidden" initial={t9} animate={t10} transition={t11} />;
    $[16] = t10;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t12 || $[19] !== t8) {
    t13 = <div className="flex-1 lg:flex-none h-0.5 lg:h-24 w-full lg:w-0.5 bg-black relative order-2">{t8}{t12}</div>;
    $[18] = t12;
    $[19] = t8;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  const t14 = String(activeIndex + 1);
  let t15;
  if ($[21] !== t14) {
    t15 = t14.padStart(2, "0");
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t15) {
    t16 = <span className="text-sm lg:text-xl font-bold text-white order-1 lg:order-3">{t15}</span>;
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t13 || $[26] !== t16 || $[27] !== t4) {
    t17 = <div className="flex flex-row lg:flex-col items-center justify-center gap-4 w-full lg:w-auto order-3 lg:order-1 mt-4 lg:mt-0">{t4}{t13}{t16}</div>;
    $[25] = t13;
    $[26] = t16;
    $[27] = t4;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  const t18 = activeData?.id;
  let t19;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      duration: 0.5
    };
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  const t20 = activeData?.image || "";
  let t21;
  if ($[30] !== t20) {
    t21 = <Image src={t20} alt="" fill={true} sizes="(max-width: 1024px) 192px, 350px" className="object-cover rounded" />;
    $[30] = t20;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] !== activeData?.video) {
    t22 = activeData?.video && <Link href={activeData?.video} className="absolute top-3 right-3 lg:top-6 lg:right-6 w-10 h-10 bg-primary text-white rounded-full flex items-center justify-center cursor-pointer"><Play className="w-4 h-4 fill-white" /></Link>;
    $[32] = activeData?.video;
    $[33] = t22;
  } else {
    t22 = $[33];
  }
  let t23;
  if ($[34] !== t18 || $[35] !== t21 || $[36] !== t22) {
    t23 = <div className="relative w-48 h-60 lg:w-87.5 lg:h-105 rotate-6 lg:rotate-6 overflow-hidden shadow-2xl z-10 transition-transform shrink-0"><AnimatePresence mode="wait"><motion.div key={t18} variants={commonImageVariants} initial="initial" animate="animate" exit="exit" transition={t19} className="absolute w-full h-full">{t21}{t22}</motion.div></AnimatePresence></div>;
    $[34] = t18;
    $[35] = t21;
    $[36] = t22;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  const t24 = activeData?.id + "_txt";
  let t25;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = {
      duration: 0.5
    };
    $[38] = t25;
  } else {
    t25 = $[38];
  }
  const t26 = activeData?.quote;
  let t27;
  if ($[39] !== t26) {
    t27 = <p className="text-lg md:text-2xl lg:text-3xl font-bold leading-snug lg:leading-snug text-white italic">{t26}</p>;
    $[39] = t26;
    $[40] = t27;
  } else {
    t27 = $[40];
  }
  const t28 = activeData?.authorAvatar;
  const t29 = activeData?.authorName;
  let t30;
  if ($[41] !== t28 || $[42] !== t29) {
    t30 = <div className="relative w-10 h-10 lg:w-14 lg:h-14 rounded-full overflow-hidden border-2 border-primary/50 shrink-0"><Image src={t28} alt={t29} fill={true} sizes="(max-width: 1024px) 40px, 56px" className="object-cover" /></div>;
    $[41] = t28;
    $[42] = t29;
    $[43] = t30;
  } else {
    t30 = $[43];
  }
  const t31 = activeData?.authorName;
  let t32;
  if ($[44] !== t31) {
    t32 = <h3 className="font-bold text-sm lg:text-lg leading-tight uppercase tracking-wider">{t31}</h3>;
    $[44] = t31;
    $[45] = t32;
  } else {
    t32 = $[45];
  }
  const t33 = activeData?.authorRole;
  let t34;
  if ($[46] !== t33) {
    t34 = <span className="text-muted-foreground text-xs lg:text-sm">{t33}</span>;
    $[46] = t33;
    $[47] = t34;
  } else {
    t34 = $[47];
  }
  let t35;
  if ($[48] !== t32 || $[49] !== t34) {
    t35 = <div className="flex flex-col text-left">{t32}{t34}</div>;
    $[48] = t32;
    $[49] = t34;
    $[50] = t35;
  } else {
    t35 = $[50];
  }
  let t36;
  if ($[51] !== t30 || $[52] !== t35) {
    t36 = <div className="flex items-center gap-3 justify-start mt-10">{t30}{t35}</div>;
    $[51] = t30;
    $[52] = t35;
    $[53] = t36;
  } else {
    t36 = $[53];
  }
  let t37;
  if ($[54] !== t24 || $[55] !== t27 || $[56] !== t36) {
    t37 = <div className="flex flex-col flex-1 justify-center gap-4 md:gap-6 lg:gap-12 text-white order-2 lg:order-3 text-left w-full"><AnimatePresence mode="wait">{" "}<motion.div key={t24} variants={commonTextVariants} initial="initial" animate="animate" exit="exit" transition={t25} className="w-full">{t27}{t36}</motion.div></AnimatePresence></div>;
    $[54] = t24;
    $[55] = t27;
    $[56] = t36;
    $[57] = t37;
  } else {
    t37 = $[57];
  }
  let t38;
  if ($[58] !== t23 || $[59] !== t37) {
    t38 = <div className="flex flex-col md:flex-row justify-center lg:justify-start items-center w-full lg:w-auto order-1 lg:order-2 py-4 gap-8 lg:gap-20">{t23}{t37}</div>;
    $[58] = t23;
    $[59] = t37;
    $[60] = t38;
  } else {
    t38 = $[60];
  }
  let t39;
  if ($[61] !== t17 || $[62] !== t38) {
    t39 = <div className="w-full h-full flex flex-col lg:flex-row gap-4 md:gap-8 lg:gap-16 items-center lg:items-center px-4 lg:px-0 bg-accent-foreground">{t17}{t38}</div>;
    $[61] = t17;
    $[62] = t38;
    $[63] = t39;
  } else {
    t39 = $[63];
  }
  return t39;
};
export default TestimonialCard;